// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { send } from '../../actions/network';
import userActions from '../../actions/user';
import deferComponentRender from '../../hocs/deferComponentRender';
import { useShallowEqualSelector } from '../../hooks';
import useMergeProps from '../../hooks/useMergeProps';
import { getPreviousMatchId } from '../../utils/history';

import RoutesLive from './RoutesLive';
import selectRouteLiveSelector from './RoutesLive.selector';

const LiveRouteContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const selectedProps = useShallowEqualSelector((state) => selectRouteLiveSelector(state, { history }));

  const askRoute = useCallback((route) => dispatch(send({ route })), [dispatch]);
  const setPreferences = useCallback((prefs) => dispatch(userActions.setPreferences('live', prefs)), [dispatch]);
  const clearPreferences = useCallback(() => dispatch(userActions.clearPreferences('live')), [dispatch]);

  const actionsProps = useMemo(
    () => ({
      askRoute,
      setPreferences,
      clearPreferences,
    }),
    [askRoute, clearPreferences, setPreferences],
  );

  const otherProps = useMemo(() => ({ anchorMatchId: getPreviousMatchId(history) }), [history]);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps, otherProps });

  return <RoutesLive {...enhancedProps} />;
};

export default deferComponentRender(LiveRouteContainer);
